import { registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const EDIT_DATA_SOURCE = registerMutation({
  fieldName: 'editDataSource',
  args: ['flowId', 'dataSourceId'],
  fetcher: ({
    flowId,
    data,
    dataSourceId
  }) => http.put(`automationplatform/v1/data-sources/flows/${flowId}/${dataSourceId}`, {
    data
  })
});